<template>
  <BaseHistory>
    <div v-if="!isLoading || histories">
      <HistoryItem
        :key="item.id"
        :item="item"
        :date="item.timedAt"
        :title="getTitle(item)"
        :icon="getIcon(item)"
        :is-error="getIsError(item)"
        :text="getText(item)"
        v-for="item in histories"
      ></HistoryItem>
      <div v-if="histories?.length == 0" class="mt-20 grey-4-color">
        {{$t('history.no_events')}}
      </div>
    </div>
    <div v-if="isLoading && !histories" class="w-full">
      <BaseItemLoader
        :loaderDistribution="['w-9/12', 'w-3/12']"
        v-for="index in 3"
        :key="index"
      />
    </div>
  </BaseHistory>
  <PaginationDefault
    v-if="
      historiesMeta && histories?.length > 0 && historiesMeta.totalPages > 1
    "
    :total="historiesMeta.total"
    :count="historiesMeta.count"
    :perPage="historiesMeta.perPage"
    :currentPage="historiesMeta.currentPage"
    :totalPages="historiesMeta.totalPages"
    :lastPage="historiesMeta.lastPage"
    :from="historiesMeta.from"
    :to="historiesMeta.to"
    @change="getData"
  ></PaginationDefault>
</template>

<script>
import { mapGetters } from "vuex";
import baseMixin from "~/mixins/base";
import historyMixin from "~/mixins/history";
import HistoryItem from "./components/UserHistoryItem.vue";
import BaseHistory from "./components/BaseHistory.vue";
import PaginationDefault from "~/components/Pagination/default.vue";

export default {
  data() {
    return {
      loadingStyle: {
        cursor: "progress"
      }
    };
  },
  mixins: [baseMixin, historyMixin],
  components: {
    PaginationDefault,
    HistoryItem,
    BaseHistory
  },
  created() {
    this.loadData(() => {
      this.$store.dispatch("userHistory/fetchUserHistories");
    });
  },
  methods: {
    async getData(page) {
      let params = {
        page: page
      };

      await this.loadData(async () => {
        await this.$store.dispatch("userHistory/fetchUserHistories", params);
      });
    }
  },
  computed: {
    ...mapGetters({
      histories: "userHistory/list",
      historiesMeta: "userHistory/meta",
      isLoadingHistories: "userHistory/isLoading"
    })
  }
};
</script>
